import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useHistory, useLocation } from "react-router-dom";

export default function TopNav({
  navTop = [],
  appTitle = "HaggleFreight",
  rightSlot,
  activeKey,
}) {
  const history = useHistory();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

 const isActive = (tab) => {
  if (!tab?.base) return false;

  return (
    tab.key === activeKey ||
    location.pathname === tab.base ||
    location.pathname.startsWith(tab.base + "/")
  );
};

  const goTo = (path) => {
    history.push(path);
    setMobileOpen(false);
  };

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          bgcolor: "#1976d2",
          borderBottom: "1px solid rgba(255,255,255,0.12)",

          // Keep content below the iPhone status bar/notch
          paddingTop: {
             xs: "env(safe-area-inset-top)",
             md: 0,
           },
          }}
      >
        <Toolbar
          sx={{
            minHeight: { xs: 56, md: 68 },
            px: { xs: 1.5, sm: 2, md: 3 },
            gap: 2,
          }}
        >
          <Typography
            onClick={() => {
              const path = location.pathname;

              if (path.startsWith('/customer')) {
                history.push('/customer/dashboard');
                return;
              }

              if (path.startsWith('/courier')) {
              history.push('/courier/dashboard');
              return;
              }

              if (path.startsWith('/admin')) {
              history.push('/admin');
              return;
              }

              history.push('/');
           }}
            sx={{
              cursor: "pointer",
              fontSize: { xs: "1.25rem", md: "1.5rem" },
              fontWeight: 800,
              letterSpacing: "-0.02em",
              mr: { xs: 0, md: 3 },
              whiteSpace: "nowrap",
              display: "flex",
              alignItems: "center",
              gap: 1,
           }}
           >
             <Box
               component="img"
               src="/logo192.png"
               alt="HaggleFreight"
               sx={{
                 width: { xs: 28, md: 32 },
                 height: { xs: 28, md: 32 },
                 objectFit: "contain",
                 flexShrink: 0,
               }}
             />
             {appTitle}
           </Typography>

          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: 0.75,
              flex: 1,
            }}
          >
            {navTop.map((tab) => (
              <Button
                key={tab.key}
                onClick={() => history.push(tab.base)}
                sx={{
                  color: "white",
                  px: { md: 1.8, lg: 2.4 },
                  py: 1,
                  minWidth: "auto",
                  borderRadius: 2,
                  fontSize: { md: "0.9rem", lg: "0.95rem" },
                  fontWeight: isActive(tab) ? 700 : 500,
                  textTransform: "none",
                  opacity: isActive(tab) ? 1 : 0.88,
                  bgcolor: isActive(tab) ? "rgba(255,255,255,0.18)" : "transparent",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    bgcolor: "rgba(255,255,255,0.16)",
                    opacity: 1,
                  },
                }}
              >
                {tab.label}
              </Button>
            ))}
          </Box>

          <Box
            sx={{
              display: { xs: "none", md: "block" },
              ml: "auto",
              "& button": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: 2,
              },
            }}
          >
            {rightSlot}
          </Box>

               <IconButton
                 type="button"
                 aria-label="Open navigation menu"
                 onClick={(event) => {
                 event.preventDefault();
                 event.stopPropagation();
                 setMobileOpen(true);
                 }}
                sx={{
                  display: { xs: "flex", md: "none" },
                  color: "white",
                  ml: "auto",

                  width: 48,
                  height: 48,
                  minWidth: 48,
                  minHeight: 48,

                  alignItems: "center",
                  justifyContent: "center",

                  position: "relative",
                  zIndex: 2,

                  flexShrink: 0,
                  borderRadius: 2,

                 WebkitTapHighlightColor: "transparent",
                 touchAction: "manipulation",
                }}
                >
  <MenuIcon
    sx={{
      fontSize: 32,
    }}
              />
           </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
         anchor="right"
         open={mobileOpen}
         onClose={() => setMobileOpen(false)}
         ModalProps={{
           keepMounted: true,
         }}
         PaperProps={{
           sx: {
            width: 280,
            maxWidth: "85vw",
            p: 2,
           },
         }}
      >
        <Typography
          sx={{
            fontSize: "1.25rem",
            fontWeight: 800,
            mb: 1.5,
          }}
        >
          {appTitle}
        </Typography>

        <Divider sx={{ mb: 1 }} />

        <List>
          {navTop.map((tab) => (
            <ListItemButton
              key={tab.key}
              selected={isActive(tab)}
              onClick={() => goTo(tab.base)}
              sx={{
                borderRadius: 2,
                mb: 0.5,
              }}
            >
              <ListItemText primary={tab.label} />
            </ListItemButton>
          ))}
        </List>

        <Divider sx={{ my: 1.5 }} />

        <Box
          sx={{
            "& button": {
              width: "100%",
              textTransform: "none",
              fontWeight: 700,
              borderRadius: 2,
            },
          }}
        >
          {rightSlot}
        </Box>
      </Drawer>
    </>
  );
}